import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';

import { InsurancePackageResolver } from '@admin/src/resolvers/insurance-package.resolver';

import { chatRoutes } from '@lib/chat/chat.routes';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/guest/guest.component').then(c => c.GuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/authorized/authorized.component').then(c => c.AuthorizedComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'clients',
      },
      {
        path: 'clients',
        loadComponent: () => import('./pages/clients/clients.component').then(c => c.ClientsComponent),
      },
      {
        path: 'insurance-packages',
        loadComponent: () => import('./pages/insurance-packages/insurance-packages.component').then(c => c.InsurancePackagesComponent),
      },
      {
        path: 'insurance-packages/create',
        loadComponent: () => import('./pages/insurance-packages/insurance-package-edit/insurance-package-edit.component').then(c => c.InsurancePackageEditComponent),
      },
      {
        path: 'insurance-packages/:packageId/edit',
        loadComponent: () => import('./pages/insurance-packages/insurance-package-edit/insurance-package-edit.component').then(c => c.InsurancePackageEditComponent),
        resolve: { insurancePackageData: InsurancePackageResolver },
      },
      {
        path: 'gift-codes/create',
        loadComponent: () => import('./pages/gift-codes/gift-codes.component').then(c => c.GiftCodesComponent),
      },
      {
        path: 'invoices/sending',
        loadComponent: () => import('./pages/sending-invoices/sending-invoices.component').then(c => c.SendingInvoicesComponent),
      },
      {
        path: 'achi-codes',
        loadComponent: () => import('../../../../packages/shared-ui/src/modules/achi-codes/achi-codes.component').then(c => c.AchiCodesComponent),
      },
      {
        path: 'diagnoses',
        loadComponent: () => import('../../../../packages/shared-ui/src/modules/diagnoses/diagnoses.component').then(c => c.DiagnosesComponent),
      },
      {
        path: 'partners',
        loadChildren: () => import('@lib/partners').then(m => m.PARTNERS_ROUTES),
      },
      {
        path: 'reports',
        loadChildren: () => import('@lib/reports').then(m => m.REPORTS_ROUTES),
      },
      {
        path: 'dictionaries',
        loadChildren: () => import('@lib/dictionaries').then(m => m.DICTIONARIES_ROUTES),
      },
      {
        path: 'chat/threads',
        loadComponent: () => import('../../../../packages/chat/src/chat.component').then(c => c.ChatComponent),
        children: chatRoutes,
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
